/** CMA 检测因子选择与基本类型映射 */

export const BASIC_TYPE_CMA_MAJOR = {
  土壤采样: '三、土壤和水系沉积物',
  沉积物采样: '三、土壤和水系沉积物',
  水质检测: '一、水（含大气降水）和废水',
  烟气检测: '二、环境空气和废气',
  烟气比对检测: '二、环境空气和废气',
  '环境空气（无组织废气）': '二、环境空气和废气',
  固体废物: '四、固体废物',
  '在线检测（加油站油气回收）': '七、油气回收',
  噪声检测: '五、噪声',
  '工频电场、磁场检测': '六、电磁辐射',
  泄露和敞开液面排放: '二、环境空气和废气'
}

export function cmaMajorForBasicType(basicType) {
  return BASIC_TYPE_CMA_MAJOR[String(basicType || '').trim()] || ''
}

export function splitItemNames(text) {
  return String(text || '')
    .split(/[、,，;；\n]/)
    .map(s => s.trim())
    .filter(Boolean)
}

export function splitItemIds(text) {
  return String(text || '')
    .split(/[,，]/)
    .map(s => s.trim())
    .filter(Boolean)
}

export function splitMethods(text) {
  return String(text || '')
    .split(/[;；\n]/)
    .map(s => s.trim())
    .filter(Boolean)
}

export function normalizeFactorName(name) {
  return String(name || '').trim().replace(/\s+/g, '')
}

/** 合并 CMA 勾选结果（按因子名去重，同名只保留一项；方法可合并） */
export function mergeCmaRows(existingIds, existingNames, existingMethods, rows) {
  const nameOrder = []
  const nameSet = new Set()
  const idByNorm = {}
  const methodSet = new Set(splitMethods(existingMethods))

  const pushName = (name, id) => {
    const n = String(name || '').trim()
    const norm = normalizeFactorName(n)
    if (!norm || nameSet.has(norm)) return false
    nameSet.add(norm)
    nameOrder.push(n)
    if (id) idByNorm[norm] = String(id)
    return true
  }

  const ids = splitItemIds(existingIds)
  splitItemNames(existingNames).forEach((n, i) => {
    pushName(n, ids[i] || '')
  })

  for (const r of rows || []) {
    const name = String(r.param_name || '').trim()
    const norm = normalizeFactorName(name)
    if (!name || !norm) continue
    const m = String(r.std_name || r.std_code || '').trim()
    if (m) methodSet.add(m)
    if (nameSet.has(norm)) continue
    const id = String(r.id || '').trim()
    pushName(name, id)
  }

  const item_ids = nameOrder
    .map(n => idByNorm[normalizeFactorName(n)] || '')
    .filter(Boolean)
    .join(',')
  return {
    item_ids,
    item_names: nameOrder.join('、'),
    method_accord: [...methodSet].join('；')
  }
}

/** 对已录入因子按名称去重（清理历史整类导入产生的重复） */
export function dedupeItemFields(item_ids, item_names, method_accord) {
  return mergeCmaRows(item_ids, item_names, method_accord, [])
}
